import styled from "@emotion/styled";

export const GreenBadgeBase = styled.div`
  display: flex;
  width: fit-content;
  padding: 14px 16px 14px 14px;
  color: #fafcff;
  border: 2px solid #49aa19;
  border-radius: 50px;
`;

export const BadgeImage = styled.img`
  width: 150px;
  margin: -30px;
  margin-right: -24px;
`;

export const BadgeIcon = styled.i`
  align-self: center;
  margin-top: -6px;
  color: #49aa19;
  font-size: 20px;
  margin-right: 8px;
  line-height: 44px;
`;

export const BadgeCopy = styled.div`
  align-self: center;
  margin-top: -2px;
`;

export const BadgeCopyHeadline = styled.div`
  font-size: 12px;
  font-weight: bold;
`;

export const BadgeCopySubheadline = styled.div`
  font-size: 12px;
`;
